import { render } from "./RegionsManagement.vue?vue&type=template&id=1787ca26&scoped=true"
import script from "./RegionsManagement.vue?vue&type=script&lang=js"
export * from "./RegionsManagement.vue?vue&type=script&lang=js"

import "./RegionsManagement.vue?vue&type=style&index=0&id=1787ca26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1787ca26"]])

export default __exports__